import React, {useState} from "react";
import "./Contact.css";

function Contact(){

const [formData,setFormData] = useState({
    name:"",
    email:"",
    phone:"",
    subject:"",
    message:""
});


const handleChange=(e)=>{
    setFormData({
        ...formData,
        [e.target.name]:e.target.value
    })
}


const handleSubmit = (e) => {
    e.preventDefault();

    const whatsappNumber = "971526103130"; 
    const message = `
New Contact Inquiry - SAH Scents

Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}
Subject: ${formData.subject}
Message:
${formData.message}
`;
    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, "_blank");
};


return(
<div className="contact-page">


<section className="contact-hero">
    <h1>Get In Touch</h1>
    <p>
    Have questions about our fragrances? 
    We are always happy to help you find your perfect scent.
    </p>
</section>



<section className="contact-container">


<div className="contact-info">


<div className="contact-box">
<h3>📞 Call Us</h3>
<p>+971 52 610 3130</p>
</div>


<div className="contact-box">
<h3>💬 WhatsApp</h3>
<p>Chat with our experts</p>
</div>


<div className="contact-box">
<h3>✉ Email</h3>
<p>sahscent@yahoo.com</p>
</div>


<div className="contact-box">
<h3>🕒 Available</h3>
<p>Mon - Sat | 24h</p>
</div>


</div>



<div className="contact-form">


<form onSubmit={handleSubmit}>


<input 
type="text"
name="name"
placeholder="Your Name"
onChange={handleChange}
/>


<input 
type="email"
name="email"
placeholder="Your Email"
onChange={handleChange}
/>


<input 
type="text"
name="phone"
placeholder="Phone Number"
onChange={handleChange}
/>


<input 
type="text"
name="subject"
placeholder="Subject"
onChange={handleChange}
/>


<textarea
name="message"
placeholder="Your Message"
onChange={handleChange}
></textarea>


<button>
Send Message
</button>


</form>

</div>


</section>

</div>
)

}


export default Contact;